import { AbstractDataProvider } from "./AbstractDataProvider";
import { GetOneParams, GetOneResult } from "react-admin";
import { getAuthenticatedServerClient, schemas } from "../api/server.api";
import { z } from "zod";

export type ReferralCodeUsageDto = z.infer<typeof schemas.ReferralCodeUsageDto>;

class ReferralCodeUsagesProvider extends AbstractDataProvider<ReferralCodeUsageDto> {
  async getOne(
    _resource: string,
    params: GetOneParams<ReferralCodeUsageDto>,
  ): Promise<GetOneResult<ReferralCodeUsageDto>> {
    const serverClient = await getAuthenticatedServerClient();
    const dto = await serverClient.getReferralCodeUsage({ params: { id: params.id } });
    return {
      data: dto,
    };
  }
}

export const referralCodeUsagesProvider = new ReferralCodeUsagesProvider();
